import AButtonIcon from '../../common/buttons/components/AButtonIcon';

import React from 'react';


function ATooltip(props) {
  const {
    children,
    onPress,
  } = props;
  return (
    <div className="a-tooltip-container"
      onClick={(e) => e.stopPropagation()}
    >
      <AButtonIcon

        icon="remove"
        iconSize="small"
        onPress={onPress}
      />
      <div className="a-tooltip-content">
        {children}
      </div>
    </div>
  );
}

export default ATooltip;
